import {cr} from 'fire-wind-water';
import {data} from './data';
import {Subject} from 'rxjs';
import {Piwik} from './piwik';
import {Thirdanalytics} from './thirdanalytics';
import {config} from '../conf/settings';
import {goto} from './goto';

const types = [
  {id: 'bigScreenId', type: 'bigScreen'}, // 线下会大屏
  {id: 'seminarId', type: 'seminar'}, // 线下会专题站
  {id: 'webinarId', type: 'webinar'}, // 线上会直播，点播
  {id: 'memberFormId', type: 'memberForm'}, // 注册表单
  {id: 'customFormId', type: 'customForm'}, // 表单
  {id: 'questionaryId', type: 'question'}, // 问卷
  {id: 'pollId', type: 'poll'}, // 投票
  {id: 'luckyDrawId', type: 'luckyDraw'}, // 抽奖
  {id: 'topicId', type: 'topic'}, // 微讨论 互动社区
  {id: 'folderId', type: 'fileFolder'}, // 文件模板文件夹
  {id: 'fileId', type: 'file'}, // 文件模板文件
  {id: 'articleCategoryId', type: 'articleCategory'}, // 文章栏目
  {id: 'articleId', type: 'article'}, // 文章
  {id: 'instanceId', type: 'instance'} // 实例ID
];

class Common {
  search: any = {};
  router: any = {};
  srJson: any = {};
  $content = new Subject<{ [label: string]: string | number }>();

  schemaId: string | number;
  tenantId: string | number;
  clientIP: string;

  instanceId: string | number;
  moduleId: string | number;
  objId: string | number;
  siteId: string | number;
  status: string | number;
  constructor() {
  }

  init() {
    if((window as any).isNotSkCommonInit){
      return;
    }
    const rurl: any = window.location.href;
    const urls: any = rurl.match(/([^?#]+)?(\?[^#]+)?(#[^?]+)?(\?[\w\W]+)?/);
    const searchs: string[] = (urls[2] || '').substr(1).split('&');
    const routers: string[] = (urls[4] || '').substr(1).split('&');
    cr.each(searchs, d => {
      const o = d.split('=');
      this.search[o[0]] = o[1];
      this.srJson[o[0]] = o[1];
    });
    cr.each(routers, d => {
      const o = d.split('=');
      this.router[o[0]] = o[1];
      this.srJson[o[0]] = o[1];
    });
    let info: any = null;
    for (let i = 0; i < types.length; i++) {
      const t = types[i];
      if (this.srJson[t.id]) {
        info = {
          id: this.srJson[t.id],
          type: t.type
        };
        break;
      }
    }
    if (info) {
      this.getJsonParams(info);
      return;
    }
    // 没有匹配到，再次尝试匹配租户id
    if (this.search && this.search.tenantId) {
      this.getJsonParams({tenantId: this.search.tenantId, id: '', type: 'tenant'});
      return;
    }
    if ((window as any).skJsonParams) {
      this.getJsonParams((window as any).skJsonParams);
    }
  }

  getJsonParams(info: any, b = false): void {
    data.getJsonParams(info).subscribe(res => {
      cr.each(res, (m, i) => {
        this[i] = m;
      });
      if(!b){
        (window as any).$sk.config.tenantId = this.tenantId;
        config.tenantId = this.tenantId;
        setTimeout(()=>{
          new Piwik(this.tenantId,  this.siteId);
          new Thirdanalytics(this.tenantId);
        }, 100);
      }
      goto.getDomain(this.tenantId);
      this.$content.next(res);
    });
  }
  // id: 444 type: bigScreenId
  initParams(o:{[label: string]: string | number}){
    let info: any = null;
    let ty = types.filter(d => {
      return d.id == o.type
    })[0] || null;
    if(ty){
      info = {
        id: o.id,
        type: ty.type
      }
    }
    if(!info && o.type === 'tenantId'){
      info = {tenantId: o.id, id: '', type: 'tenant'}
    }
    if (info) {
      this.getJsonParams(info);
    }
  }
}

export const common = new Common();